function initStickyBanner() {
  const stickyBanner = document.getElementById("sticky-banner");
  const ctaButton = document.querySelector(".product__cta-button.btn");
  const stickyBtn = document.getElementById("sticky-banner-btn");
  if (!stickyBanner || !ctaButton || !stickyBtn) return;

  function checkVisibility() {
    if (!ctaButton) return;
    const rect = ctaButton.getBoundingClientRect();

    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

    stickyBanner.style.display = isVisible ? "none" : "flex";

    const miniCartActive =
      document.querySelector(".mini-cart.mini-cart--active") !== null;
    if (miniCartActive && stickyBanner.style.display === "flex") {
      stickyBanner.style.display = "none";
    } else if (!miniCartActive && !isVisible) {
      stickyBanner.style.display = "flex";
    }

    const teaser = document.querySelector(
      ".needsclick.kl-teaser-WCWnfU.undefined.kl-private-reset-css-Xuajs1"
    );
    if (teaser) {
      teaser.style.bottom = isVisible ? "0px" : "115px";
    }

    const teaserMobile = document.querySelector(
      ".needsclick.kl-teaser-RmQubu.undefined.kl-private-reset-css-Xuajs1"
    );
    if (teaserMobile) {
      if (window.innerWidth <= 767) {
        teaserMobile.style.bottom = isVisible ? "0px" : "70px";
      } else {
        teaserMobile.style.bottom = "0px";
      }
    }
  }

  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility);
  checkVisibility();

  const observer = new MutationObserver(() => {
    const miniCartActive = document.querySelector(".mini-cart.mini-cart--active") !== null;
    if (miniCartActive) {
      stickyBanner.style.display = "none";
    } else {
      checkVisibility();
    }
  });

  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });

  stickyBtn.addEventListener("click", function () {
    if (ctaButton) {
      ctaButton.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
}

initStickyBanner();
